import * as styles from "./RelationItem.css";

import { Icon } from "@frontend/components/atoms/Icon";

import type { RelationLink } from "../../types";
import { entityIcon } from "./entities";

/**
 * A record the contact is tied to. Rendered as a link because it leads out of
 * the address book, into the page of that record.
 */
export function RelationItem({ link }: { readonly link: RelationLink }) {
  return (
    <li>
      <a className={styles.item} href={link.url}>
        <Icon
          name={entityIcon(link.entity)}
          size="sm"
          className={styles.icon}
        />

        <span className={styles.name}>{link.displayName}</span>

        {/* A direct link needs no second line: the record carries the
            contact's own name, and the heading says what it is */}
        {link.role !== null && <span className={styles.role}>{link.role}</span>}
      </a>
    </li>
  );
}
